import * as React from "react";
import { useMemo } from "react";
import usePluginEntities from "hooks/usePluginEntities";
const FormatAssetList = ({ associated_assets }) => {
  const pluggableAssetListComponent = usePluginEntities("views.components.assetInformationActions");
  const assetsList = useMemo(
    () => pluggableAssetListComponent.map(({ component: PluggableAssetListItem }) => /* @__PURE__ */ React.createElement(PluggableAssetListItem, { key: associated_assets[0], assetIds: associated_assets, direction: "col" })),
    [pluggableAssetListComponent, associated_assets]
  );
  if (associated_assets.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", null, assetsList.map((assetElement) => /* @__PURE__ */ React.createElement("div", { key: assetElement.props.assetIds[0] }, assetElement)));
};
export default FormatAssetList;
